import { ChangeDetectionStrategy, Component, ElementRef, input, Input, OnInit, Signal, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { WebElement, Result } from '../../../../state-management/model/interfaces/state.model';
import { ElementsType, StyleType } from '../../../../state-management/model/enums/state.enums';
import { CommonModule } from '@angular/common';
import { MetaConfigComponent } from '../../text/meta-config/meta-config.component';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ButtonActionsComponent } from '../button-actions/button-actions.component';
import { ScrollService } from '../../../../services/scroll.service';
import { ClickOutsideDirective } from '../../../../directives/click-outside.directive';

@Component({
  selector: 'app-editable-button',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIcon,
    MetaConfigComponent,
    ButtonActionsComponent,
    ClickOutsideDirective
  ],
  templateUrl: './editable-button.component.html',
  styleUrl: './editable-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditableButtonComponent implements OnInit {
  readonly buttonElementRef = viewChild.required('buttonElement', { read: ElementRef });
  elemId = input.required<string>();
  customClass = input<string | null>(null);

  public eType = ElementsType.Button;
  public styles$!: Signal<Partial<Record<StyleType, string>>>;

  public showEditButton: boolean = false;
  public metaConfigOpen: boolean = false;
  public buttonConfigOpen: boolean = false;

  public isEditMode$: Signal<boolean> = this.stateService.isEditMode;
  public currentElement$!: Signal<Result<WebElement, string>>;

  ngOnInit(): void {
    this.currentElement$ = this.stateService.getCurrentElement(this.elemId());
    this.styles$ = this.stateService.getStylesForElement(this.elemId());
  }

  public async onClick() {
    this.scollService.onClick(this.elemId());
  }

  public onClickOutside(): void {
    this.closeAllConfig();
  }

  public openConfig(event: Event, target: 'button' | 'meta'): void {
    event.stopPropagation(); // Verhindert, dass der Klick das Feld erneut fokussiert
    if (target === 'button') {
      this.buttonConfigOpen = true;
      this.metaConfigOpen = false;
    } else {
      this.metaConfigOpen = true;
      this.buttonConfigOpen = false;
    }
  }

  public closeAllConfig(): void {
    this.metaConfigOpen = false;
    this.buttonConfigOpen = false;
    this.showEditButton = false;
  }

  public onEdit(): void {
    if (this.isEditMode$()) {
      this.showEditButton = true;
    }
  }

  public onBlur(event: Event) {
    const currentElement = this.currentElement$();
    if (currentElement.success) {
      const previousValue = currentElement.payload.value;
      const currentValue = (event.target as HTMLElement).innerText.trim();

      if (currentValue !== previousValue) {
        this.stateService.updateElement(this.elemId(), { value: currentValue });
      }
    }
  }

  constructor(
    private scollService: ScrollService,
    private stateService: WebsiteStateService
  ) { }
}